import { QuestionTimeComponent } from './question-time.component';

export default angular
  .module('sfMobile.components.question-time', [
    'sfMobile.components.input-time',
  ])
  .component('sfQuestionTime', QuestionTimeComponent).name;
